import boardCertified from '../images/boardCertified.webp';
import nationalTrialLawyersTop100 from '../images/nationalTrialLawyersTop100.webp';
import nacdaTopTen2025 from '../images/nacdaTopTen2025.webp';
import texasBarCollege from '../images/texasBarCollege.webp';

// Bio paragraphs at the top of the About page, telling Joe's story in order
export const aboutBio = [
	"Raised outside Austin, Joe Wells was a top student and football captain. A scholarship took him to Southern Methodist University, where an injury shifted his path toward law, and at South Texas College of Law he found his passion for advocacy.",
	"Early in his career, Joe worked on the landmark Texas lawsuit against tobacco manufacturers in the office of trial lawyer John Eddie Williams. In 2005, he opened his own practice defending individuals in Houston and beyond.",
	"With nearly two decades of experience, Joe is known as one of Houston's most effective criminal trial lawyers. He was recognized as Harris County’s top criminal defense lawyer in 2024 and is a member of the National Trial Lawyers Top 100.",
];

export interface Award {
	image: string;
	title: string;
	organization: string;
	// The image is white-only and needs darkening to show on the white strip
	invertImage?: boolean;
}

// Award logos shown in the Recognition strip, in order
export const awards: Award[] = [
	{
		image: boardCertified,
		title: "Board Certified in Criminal Law",
		organization: "Texas Board of Legal Specialization",
		invertImage: true,
	},
	{
		image: nationalTrialLawyersTop100,
		title: "Top 100 Trial Lawyers",
		organization: "The National Trial Lawyers",
	},
	{
		image: nacdaTopTen2025,
		title: "Top Ten Ranking, 2025",
		organization: "NACDA",
	},
	{
		image: texasBarCollege,
		title: "Proud Member",
		organization: "Texas Bar College",
	},
];
